import { Events } from '@ui/Search/Form/Fields/Autocomplete/component'
import SearchResult from '@ui/Search/Result/component'
import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import common from 'assets/themes/campings/js/page/common/index'
import { openMap } from 'assets/themes/campings/js/page/search/map'
import type { Calendar as SearchCalendarType } from '@ui/Search/Calendar/component'
import type { SearchMobileRecapType } from '@ui/Search/MobileRecap/component'
import type { SidePanelType } from '@ui/SidePanel/component'

const calendarId = 'search_offers_checkInDate'

const setAutocompleteProductId = (id: string | null, name: string | null): void => {
  const calendar = ElementPropertiesManager.getProperty<SearchCalendarType>(document.getElementById(calendarId) as HTMLInputElement, 'calendar')

  if (!id || !name || !calendar) {
    return
  }

  const autocompleteEl = document.getElementById('search_offers_autocomplete_autocomplete')

  if (!autocompleteEl) {
    return
  }

  const eventData = {
    token: '',
    name,
    nameHighlight: '',
    description: '',
    detail: {
      id: parseInt(id, 10),
      category: 'product',
      source: 'product.click',
    },
  }

  const fn = (): void => {
    if (calendar.input.value !== '') {
      autocompleteEl?.dispatchEvent(
        new CustomEvent(Events.AUTOCOMPLETE_SET_DATA, {
          detail: eventData,
        })
      )
    }

    calendar.input.removeEventListener('calendar.close', fn)
  }

  calendar.input.addEventListener('calendar.close', fn)
}

const openCalendar = (el: HTMLElement): void => {
  const calendar = ElementPropertiesManager.getProperty<SearchCalendarType>(document.getElementById(calendarId) as HTMLInputElement, 'calendar')
  const searchBlockEl = document.querySelector('.search__block')

  if (!calendar) {
    return
  }

  if (!common.isMobile()) {
    calendar.open()

    if (!searchBlockEl || searchBlockEl) {
      calendar.element.scrollIntoView({
        block: 'start',
        inline: 'nearest',
      })
    }

    setAutocompleteProductId(el.getAttribute('data-id'), el.getAttribute('data-name'))
  }

  if (common.isMobile() || common.isTablet()) {
    const sidePanelEl = document.getElementById('search-filters-side-panel')
    const recapMobilePanelEl = document.getElementById('search-mobile-recap')

    if (sidePanelEl) {
      const sidePanel = ElementPropertiesManager.getProperty<SidePanelType>(sidePanelEl, 'sidePanel')

      if (!sidePanel) {
        return
      }

      sidePanel.open()

      const tab = sidePanel.element ? <HTMLInputElement>sidePanel.element.querySelector('.tab__item[data-target="search"]') : null
      if (tab) {
        tab.click()
      }
    }

    if (recapMobilePanelEl) {
      const recapPanel = ElementPropertiesManager.getProperty<SearchMobileRecapType>(recapMobilePanelEl, 'searchMobileRecap')

      if (!recapPanel) {
        return
      }

      recapPanel.open()
    }

    calendar.open()

    setAutocompleteProductId(el.getAttribute('data-id'), el.getAttribute('data-name'))
  }
}

const openProduct = (linkEl: HTMLLinkElement, card: HTMLElement): void => {
  if (!linkEl) {
    return
  }

  let url = linkEl.href

  if (card.hasAttribute('data-url-with-anchor')) {
    url = card.getAttribute('data-url-with-anchor') as string
  }

  if (!common.isMobile()) {
    window.open(url)
  } else {
    document.location.href = url
  }
}

export default function (): void {
  document.querySelectorAll<HTMLElement>('.results .search-result').forEach((el) => {
    const productCardEl = el.querySelector<HTMLElement>('.product-card')

    if (!productCardEl) {
      return
    }

    const linkEl = productCardEl.querySelector<HTMLLinkElement>('.product-card__link')

    SearchResult(
      el,
      {
        onClickCard: (card) => {
          const event = new CustomEvent('productPageLink.opened', {
            detail: { productId: card.getAttribute('data-id') as string },
          })
          window.dispatchEvent(event)
        },
        onClickViewBtn: (card) => {
          if (card.hasAttribute('data-with-bestoffer') || card.hasAttribute('data-unavailable-best-offer')) {
            if (!linkEl) {
              return
            }

            linkEl.click()
          } else {
            openCalendar(card)
          }
        },
        onClickViewOnMapBtn: (card) => {
          openMap(card.getAttribute('data-id') as string)
        },
        pluginsConfig: {
          favorite: {
            addedSnackbar: document.getElementById('favorite_snackbar_added') as HTMLElement,
            addFailedSnackbar: document.getElementById('favorite_snackbar_add_failed') as HTMLElement,
            removedSnackbar: document.getElementById('favorite_snackbar_removed') as HTMLElement,
          },
        },
      },
      {
        onClickImage(card) {
          linkEl && openProduct(linkEl, card)
        },
        onClickCard: (card) => {
          linkEl && openProduct(linkEl, card)
        },
        onClickChangeDateBtn: (card) => {
          openCalendar(card)
        },
      }
    )
  })
}
